import { WEB_COMPONENT_GZ_OPERATING_SYSTEM_FILTER } from '../../webcomponents.constants';
import { GzOperatingSystemFilterWebComponent } from './component/GzOperatingSystemFilterWebComponent';

export { GzOperatingSystemFilterWebComponent };

window.customElements.define(WEB_COMPONENT_GZ_OPERATING_SYSTEM_FILTER, GzOperatingSystemFilterWebComponent);
